export default __webpack_public_path__ + "static/media/coursera.dcdc3205.png";